import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type AdminStats = {
  users_total: number;
  users_active: number;
  pets_total: number;
  vendors_total: number;
  vendors_pending_review: number;
  vendors_verified: number;
  bookings_total: number;
  bookings_upcoming: number;
  /** Counts an admin can act on right now — each maps to a filtered list. */
  queues: {
    vendors_awaiting_kyc: number;
    support_open: number;
    reviews_reported: number;
    orders_pending_payment: number;
    bookings_awaiting_vendor: number;
    account_deletions_pending: number;
  };
  revenue: {
    today_inr: string;
    month_inr: string;
    last_14_days: { date: string; net_inr: string }[];
  };
  recent: {
    kyc_submissions: {
      vendor_profile_id: string;
      business_name: string | null;
      city: string | null;
      module_types: string[];
      submitted_at: string;
    }[];
    support_requests: {
      id: string;
      kind: string;
      module_type: string;
      status: string;
      created_at: string;
    }[];
    bookings: {
      id: string;
      module_type: string;
      status: string;
      price_inr: string;
      vendor_business_name: string | null;
      created_at: string;
    }[];
  };
  /** What this environment actually talks to, read from the server's config. */
  integrations: {
    payments: 'razorpay' | 'dummy';
    sms: 'msg91' | 'stub';
    push: 'fcm' | 'stub';
    storage: 's3' | 'stub';
  };
};

async function fetch_stats(): Promise<AdminStats> {
  const res = await api.get<AdminStats>('/admin/stats');
  return res.data;
}

export function use_admin_stats() {
  return useQuery({
    queryKey: ['admin-stats'],
    queryFn: fetch_stats,
    // The dashboard is what an admin leaves open; a stale queue count is the
    // one thing it must not show.
    refetchInterval: 60_000,
  });
}
